/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Add_New_AddressInputs */

const en_orders_add_new_address = /** @type {(inputs: Orders_Add_New_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add new address`)
};

const es_orders_add_new_address = /** @type {(inputs: Orders_Add_New_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar nueva direccion`)
};

/**
* | output |
* | --- |
* | "Add new address" |
*
* @param {Orders_Add_New_AddressInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_add_new_address = /** @type {((inputs?: Orders_Add_New_AddressInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Add_New_AddressInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_add_new_address(inputs)
	return es_orders_add_new_address(inputs)
});